"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const assured_1 = __importDefault(require("../../assured"));
const basePolicy_1 = __importDefault(require("../basePolicy"));
class OceanCargoEurope extends basePolicy_1.default {
    constructor(basePolicyData, data) {
        super(basePolicyData);
        this.assured = data.assured;
        this.files = data.files;
        this.additionalComments = data.additionalComments;
    }
    static empty() {
        return new OceanCargoEurope(Object.assign({}, basePolicy_1.default.empty()), {
            assured: assured_1.default.empty(),
            files: [],
            additionalComments: ""
        });
    }
    static createPolicy(partnerIds, policyRequest, sandbox, projectId, sanctionsChecks, data) {
        const basePolicy = basePolicy_1.default.create({
            partnerIds,
            policyRequest,
            projectId,
            sandbox,
            sanctionsChecks
        });
        return new OceanCargoEurope(basePolicy, {
            files: data === null || data === void 0 ? void 0 : data.files,
            assured: data === null || data === void 0 ? void 0 : data.assured,
            additionalComments: data === null || data === void 0 ? void 0 : data.additionalComments
        });
    }
    static fromObj(data) {
        if (!data) {
            return OceanCargoEurope.empty();
        }
        return new OceanCargoEurope(Object.assign({}, basePolicy_1.default.fromObj(data)), {
            assured: assured_1.default.fromObj(data.assured),
            files: data.files || [],
            additionalComments: data.additionalComments || ""
        });
    }
}
exports.default = OceanCargoEurope;
//# sourceMappingURL=oceanCargoEurope.class.js.map